import React from 'react';
import {connect} from 'react-redux';
import {
    ActionDescriptorsPlanTypes,
    ActionPlanTypesAdd, ActionPlanTypesDelete,
    ActionPlanTypesEdit
} from "../../../parts/actions";
import {Link} from "react-router-dom";
import ColumnResizer from "react-column-resizer";
import Storege from "../../../storage/storage";
import ToolButtons from "../../../parts/ToolButtons";
import Search from "../../../parts/Search";
import PlanTypePopup from "./PlanTypePopup";
import api from "../../../api";
import RemoveButton from "../../../parts/removeBtn";
import CommonTab from "../../../parts/CommonTabClass";
import {doFilter} from "../../../parts/functions";
import EditBtn from "../../../parts/EditBtn";

class PlanTypesDescriptorComponent extends CommonTab {

    orderFields = {
        "Plan Type Name": "plantypename",
        "Plan Type Name Eng": "plantypenameeng"
    };

    state = {
        planType: {},
        popup: false,
        popupType: undefined,
        order: null,
        searchValue: '',
        currentItemIndex: -1
    };

    constructor(props) {
        super(props);
        this.state.planType = props.planType;
    }

    changePopupType = (actionType) => {
        this.setState({
            popupType: actionType
        })
    };

    changePopupState = () => {
        let currentPopupState = this.state.popup;
        this.setState(
            {
                popup: !currentPopupState
            }
        )
    };

    addContentType = (object) => {
        ActionPlanTypesAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD DESCRIPTOR PLAN TYPE',
                item: data
            });
            this.changePopupState();
            this.props.history.push(data.plantypeid);
        });
    };

    editContentType = (object) => {
        ActionPlanTypesEdit(object.plantypeid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE DESCRIPTOR PLAN TYPE',
                item: data,
                id: data.plantypeid
            });
            this.changePopupState();
            this.props.history.push(data.plantypeid);
        });
    };

    getId(pathName) {
        let path = (pathName).split('/');
        let id = path[path.length - 1];
        return id;
    }

    changeState = (name, e, id) => {
        let temp = this.props.planType;
        temp.forEach(function (item) {
            if (item.plantypeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            planType: Object.assign({}, temp)
        });
    };

    render() {
        if (!this.props.planType.length) {
            ActionDescriptorsPlanTypes();
        }
        let {planType} = this.props;
        let {searchValue } = this.state;
        if (!planType) {
            return (
                <div className="overlay-loader">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }

        let outPutPlaces = planType;
        outPutPlaces = doFilter(
            outPutPlaces,
            [
                {
                    name: 'searchValue',
                    value: searchValue,
                    searchId: [
                        'plantypename',
                        'plantypenameeng'
                    ]
                }
            ]
        );

        this.sortResults(outPutPlaces);
        return (
            <div>
                <div className="inline-toolbuttons">
                    <h3>Plan Types:</h3>
                    <div className={'tool-bar'}>
                        <ToolButtons
                            actionType={this.changePopupType}
                            popupChange={this.changePopupState}
                            url={this.props.location.pathname}
                        />
                        <Search
                            change={this.search}
                        />
                    </div>
                </div>
                <table className='table table-striped'>
                    <thead>
                    {this.orderPanel()}
                    </thead>
                    <tbody>
                    {outPutPlaces.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td className={'flex-row'}>
                                    <RemoveButton
                                        action={ActionPlanTypesDelete}
                                        id={item.plantypeid}
                                        descriptor={'REMOVE DESCRIPTOR PLAN TYPE'}
                                    />
                                    <EditBtn
                                        actionType={this.changePopupType}
                                        popupChange={this.changePopupState}
                                        change={this.setCurrentIndex}
                                        id={item.plantypeid}
                                    />
                                </td>
                                <td>
                                    <Link to={api.getRoute('plan_descriptors/plan_types/' + item.plantypeid)}>
                                        {item.plantypename}
                                    </Link>
                                </td>
                                <ColumnResizer className="columnResizer" minWidth={5}/>
                                <td>
                                    <Link to={api.getRoute('plan_descriptors/plan_types/' + item.plantypeid)}>
                                        {item.plantypenameeng}
                                    </Link>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
                {this.state.popup ? <PlanTypePopup
                    openClose={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        planType: state.planType
    }
};
const DescriptorPlanTypes = connect(mapStateToProps)(PlanTypesDescriptorComponent);

export default DescriptorPlanTypes;